import { useState, useEffect } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import axios from "../../../axios";
import * as styled from "./PausedStudents.styled";
import { getAllStudents } from "../../../helpers/getAllStudents";
import { useNavigate } from "react-router-dom";

function PausedStudents() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()
  const fetchPausedStudents = async () => {
    try {
      setLoading(true);
      const res = await getAllStudents();
      const paused = res.filter((student) => student.isPaused === true);
      setStudents(paused);
    } catch (err) {
      console.error("Error fetching students:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPausedStudents();
  }, []);

  const handleUnpause = async (studentId, teacherId) => {
    try {
      await axios.put(`/student/pause/${studentId}`, {
        isPaused: false,
        pauseNote: "",
        teacherId: teacherId
      });
      fetchPausedStudents();
    } catch (err) {
      console.error("Error unpausing student:", err);
    }
  };
  console.log(students)
  return (
    <PagesWrapper>
      <TopPageTitle value={"Учні на паузі"} />
      {loading ? (
        <styled.LoadingText>Завантаження...</styled.LoadingText>
      ) : (
        <styled.StudentList>
          {students.map(({ _id, name, teacherName, pauseNote, teacherId, studentId, phoneNumber, ageGroup, classSchedule}) => (
            <styled.StudentCard key={_id}>
              <styled.Info>
                <styled.Name onClick={() => navigate(`/admin/ourstudents/${ageGroup}/${_id}`)}>{name} id({studentId})</styled.Name>
                {teacherName && <styled.Teacher onClick={() => navigate(`/admin/ourteachers/${teacherId}`)}>Викладач: {teacherName}</styled.Teacher>}
                <styled.Note>Деталі: {pauseNote || "не вказано"}</styled.Note>
                <styled.Note>Номер телефону: {phoneNumber}</styled.Note>
                {classSchedule.map(({day, time}) => (
                  <>
                     <styled.Note>{day}: {time}</styled.Note>
                  </>
                ))}
              </styled.Info>
              <styled.UnpauseButton onClick={() => handleUnpause(_id, teacherId)}>
                Зняти з паузи
              </styled.UnpauseButton>
            </styled.StudentCard>
          ))}
        </styled.StudentList>
      )}
    </PagesWrapper>
  );
}

export default PausedStudents;

